import React, { useMemo } from 'react';
import { AvatarSSvg } from '../svg/AvatarSSvg';
const Avatar = ({ isOnLine, imageUrl, className, size }) => {
    const getSizeSVG = useMemo(() => {
        switch (size) {
            case 'xs':
                return '24';
            case 's':
                return '32';
            case 'm':
                return '48';
            case 'l':
                return '80';
            case 'xl':
                return '112';
            case 'xxl':
                return '176';
        }
    }, [size]);
    const renderAvatar = useMemo(() => {
        const classNameAvatar = 'avatar avatar-' + (size ? size : 's') + ' ' + className;
        if (imageUrl) {
            return (React.createElement("div", { className: classNameAvatar },
                isOnLine && React.createElement("span", { className: 'avatar-on-line' }),
                React.createElement("img", { src: imageUrl, className: classNameAvatar, alt: 'Аватар' })));
        }
        else {
            return (React.createElement("div", { className: classNameAvatar },
                isOnLine && React.createElement("span", { className: 'avatar-on-line' }),
                React.createElement("div", { className: 'd-flex' },
                    React.createElement(AvatarSSvg, { height: getSizeSVG, width: getSizeSVG }))));
        }
    }, [className, getSizeSVG, imageUrl, isOnLine, size]);
    return React.createElement(React.Fragment, null, renderAvatar);
};
export { Avatar };
//# sourceMappingURL=Avatar.js.map